<template>
  <transition name="app-view" mode="out-in" appear>
    <div v-if="show">
      <corner-ribbon :text="ribbonText" v-if="ribbonText" />
      <pno-navigation />
      <div id="main" class="pt-1 py-sm-3">
        <router-view :key="$route.fullPath"></router-view>
      </div>
    </div>
  </transition>
</template>

<style lang="scss">

.app-view-enter-active,
.app-view-leave-active {
  transition: opacity 0.2s ease-in;
}

.app-view-enter,
.app-view-leave-to {
  opacity: 0;
}
</style>

<script>
  import '@/assets/main.scss'
  import PnoNavigation from '@/components/PnoNavigation.vue'
  import 'vuejs-noty/dist/vuejs-noty.css'
  import CornerRibbon from '@/components/CornerRibbon.vue'

  export default {
    components: { PnoNavigation, CornerRibbon },
    computed: {
      pnoCompany: function () {
       // return this.$store.state.app.pnoCompany
      },
      show: function () {
          return true
       // return this.$store.state.app.show
      },
      ribbonText: function () {
        return window.envConfig.UI_ENV
      },
    },
    mounted() {
      // fade in
      //this.$store.dispatch('app/start')
    },
    metaInfo: {
      titleTemplate: (titleChunk) => titleChunk ? `${titleChunk} | PNO Tire Report` : 'PNO Tire Report'
    }
  }
</script>
